export const characters = [
  'C-001|NewYorkHipsterFemale',
  'C-002|Grandma',
  'C-003|TeenagerMale',
  'C-004|TeenagerFemale',
  'C-005|Boy',
];
